import React from 'react';

import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';
import LoadAbout from 'bundle-loader?lazy&name=about!./routes/about/about.jsx';

export const routes = [
    {
        pattern: '/',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Behavior Hatch'
    },
    {
        pattern: '/home',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Behavior Hatch'
    },
    {
        pattern: '/about',
        load: LoadAbout,
        requireAuthentication: true,
        title: 'About'
    }
];

const Bundle = ( Component ) => (
     
    ( props ) => (
        <Component { ...props } />
    )
);

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}